import z from 'zod';

export const IqActionSchema = z.object({
    name: z.string(),
    payload: z.any().optional()
});

/*****/

export type IqAction = z.infer<typeof IqActionSchema>;
